<template>
  <FormKit label="Imported From" name="importedFromPath" type="text" validation="length:0,255" />

  <FieldSet>
    <template #1>
      <FormKit
        label="Document Date"
        name="documentDate"
        type="datepicker"
        validation="has_no_validation"
        :sequence="['day']"
        :format="appSettings.datepickerFormatDay"
        :value-format="appSettings.datepickerDayValueFormat"
      />
    </template>
    <template #2>
      <FormKit label="Storage Container" name="storageContainer" type="text" validation="length:0,20" />
    </template>
  </FieldSet>
  <FieldSet>
    <template #1>
      <FormKit
        label="Public?"
        name="forPublic"
        type="booleanRadio"
        validation="has_no_validation"
        :options="[
          { label: 'Yes', value: true },
          { label: 'No', value: false },
          { label: 'By Request', value: null },
        ]"
        :value="false"
      />
    </template>
    <template #2>
      <FormKit label="Confidential Comment" name="confidentialComment" type="text" validation="length:0,255" />
    </template>
  </FieldSet>

  <FieldSet>
    <template #1>
      <FormKit label="Sent From Individual" name="sentFromIndividual" type="text" validation="length:0,255" />
    </template>
    <template #2>
      <FormKit label="Sent From Organization" name="sentFromOrganization" type="text" validation="length:0,255" />
    </template>
  </FieldSet>

  <FieldSet>
    <template #1>
      <FormKit label="Sent To Individual" name="sentToIndividual" type="text" validation="length:0,255" />
    </template>
    <template #2>
      <FormKit label="Sent To Organization" name="sentToOrganization" type="text" validation="length:0,255" />
    </template>
  </FieldSet>

  <FieldSet :columns="3">
    <template #1>
      <FormKit label="Corr Log No." name="corrLogNumber" type="text" validation="length:0,15" />
    </template>
    <template #2>
      <FormKit label="Governor No." name="governorNumber" type="text" validation="length:0,15" />
    </template>
    <template #3>
      <FormKit label="Director No." name="directorNumber" type="text" validation="length:0,15" />
    </template>
  </FieldSet>

  <FormKit label="Notes" name="notes" type="textarea" validation="has_no_validation" />
</template>

<script lang="ts">
export default defineComponent({
  name: "DocumentEditPageExtension",
});
</script>

<script setup lang="ts" generic="T extends Doc">
import { useAppSettingsStore } from "@modernary/mui/components/common";
import type { Doc } from "@modernary/mui/components/document";
import { FieldSet } from "@modernary/mui/components/form";
import { defineComponent, watch } from "vue";

const props = defineProps<{ item?: T }>();
const appSettings = useAppSettingsStore();
</script>
